import { useFormikContext } from "formik";
import { FormInputProps } from "src/components/Inputs/FormInput";
import { generateKey } from "src/scenes/orgAdmin/formTemplates/ContentTab/V3/autoGenerateKey";
import { z } from "zod";
import { useEditFormTemplateContext } from "../../../context";
import { InputControlWithQuestionId } from "../InputControlWithQuestionId";
import * as QuestionKey from "./QuestionKey";

export const FormikSchema = z
  .object({
    title: z.string().min(1, "This field is required"),
  })
  .and(QuestionKey.FormikSchema);

export type FormikType = z.infer<typeof FormikSchema>;

interface QuestionTitleProps extends FormInputProps {
  questionId: uuid;
}

export function QuestionTitle(props: QuestionTitleProps) {
  const { questionId, ...formInputProps } = props;
  const formik = useFormikContext<FormikType>();

  const context = useEditFormTemplateContext();
  const isUnpublishedQuestion =
    context.helpers.isUnpublishedQuestion(questionId);

  return (
    <InputControlWithQuestionId
      name="title"
      label="Question title"
      inputProps={{
        ...formInputProps,
        as: "textarea",
        minHeight: "2.5em",
        paddingTop: "2",
        onChange: async (event) => {
          const title = event.target.value;
          await formik.setFieldValue("title", title, false);
          if (isUnpublishedQuestion && !formik.values.userGeneratedKey) {
            await formik.setFieldValue("key", generateKey(title), false);
          }
        },
      }}
      questionId={questionId}
    />
  );
}
